import ToggleSwitch from "@/components/shared/ToggleSwitch";
import { ConfirmModal } from "@/components/shared/ConfirmModal";
import useFeatureFlagsAdmin from "./hooks/useFeatureFlagsAdmin";
import {
  headerRowStyle,
  headerCellStyle,
  bodyCellStyle,
  nameCellStyle,
  tableContainerStyle,
  zebraRowStyle,
} from "./tableStyles";

export default function FeatureFlagsSection() {
  const {
    flags,
    isLoading,
    saving,
    error,
    pendingToggle,
    handleToggleRequest,
    handleCancelToggle,
    handleConfirmToggle,
  } = useFeatureFlagsAdmin();

  return (
    <section>
      {error && (
        <div
          role="alert"
          style={{
            padding: "0.75rem 1rem",
            marginBottom: "1rem",
            borderRadius: "0.375rem",
            border: "1px solid #fecaca",
            backgroundColor: "#fef2f2",
            color: "#991b1b",
            fontSize: "0.875rem",
          }}
        >
          {error instanceof Error ? error.message : "Something went wrong"}
        </div>
      )}
      {isLoading ? (
        <div className="text-muted">Loading feature flags…</div>
      ) : flags.length === 0 ? (
        error ? null : (
          <div className="text-muted">No feature flags found.</div>
        )
      ) : (
        <div style={tableContainerStyle}>
          <table className="table mb-0" style={{ tableLayout: "auto" }}>
            <thead>
              <tr style={headerRowStyle}>
                <th scope="col" style={headerCellStyle()}>
                  Name
                </th>
                <th scope="col" style={headerCellStyle()}>
                  Enabled
                </th>
              </tr>
            </thead>
            <tbody>
              {flags.map((flag, index) => (
                <tr key={flag.name} style={zebraRowStyle(index)}>
                  <td style={nameCellStyle}>{flag.name}</td>
                  <td style={bodyCellStyle}>
                    <ToggleSwitch
                      checked={!!flag.isEnabled}
                      onChange={() => handleToggleRequest(flag)}
                      label={`Toggle ${flag.name}`}
                      disabled={saving}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {pendingToggle && (
        <ConfirmModal
          title={`Turn ${pendingToggle.isEnabled ? "off" : "on"} "${pendingToggle.name}"?`}
          message={
            <>
              This will turn <strong>{pendingToggle.name}</strong>{" "}
              {pendingToggle.isEnabled ? "off" : "on"} and will affect
              site-level functionality for all users.
            </>
          }
          confirmText={pendingToggle.isEnabled ? "Turn Off" : "Turn On"}
          cancelText="Cancel"
          onCancel={handleCancelToggle}
          onConfirm={handleConfirmToggle}
        />
      )}
    </section>
  );
}
